export const firebaseConfig = {
  apiKey: "AIzaSyAxThapx2QcFxP5it-3ChecYyrp1_1p2RY",
  authDomain: "northseafood-qa-app.firebaseapp.com",
  databaseURL: "https://northseafood-qa-app.firebaseio.com",
  projectId: "northseafood-qa-app",
  storageBucket: "northseafood-qa-app.appspot.com",
  messagingSenderId: "741835654313",
  appId: "1:741835654313:web:0dc8688dd059d8702155b8"
}

export const FUNCTIONS_END_POINT_URL = 'https://us-central1-northseafood-qa-app.cloudfunctions.net';



// WEBPACK FOOTER //
// ./src/config/firebase-config.ts